"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MenuList = _interopRequireDefault(require("@eig-builder/core-ui/MenuList"));

var _Typography = _interopRequireDefault(require("@eig-builder/core-ui/Typography"));

var _styles = require("@eig-builder/core-ui/styles");

require("./lang");

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var styles = function styles(theme) {
  return {
    label: {
      background: theme.palette.lightGray.main,
      padding: theme.spacing(2, 4)
    },
    menuList: {
      padding: 0
    }
  };
};

var DomainSelectorGroup = function DomainSelectorGroup(_ref) {
  var classes = _ref.classes,
      onMenuItemBtnClick = _ref.onMenuItemBtnClick,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2",
    className: classes.label
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "modules.navigation.siteselector.group.domains"
  })), /*#__PURE__*/_react["default"].createElement(_MenuList["default"], {
    className: classes.menuList
  }, children && _react["default"].Children.map(children, function (child) {
    return _react["default"].cloneElement(child, {
      onMenuItemBtnClick: onMenuItemBtnClick
    });
  })));
};

DomainSelectorGroup.propTypes = {
  classes: _propTypes["default"].object,
  children: _propTypes["default"].node,
  onMenuItemBtnClick: _propTypes["default"].func
};

var _default = (0, _styles.withStyles)(styles)(DomainSelectorGroup);

exports["default"] = _default;